/**
 * Returns URL params.
 * @return {object}
 */
const getUrlParams = () => {
  const paramQueries = window.location.search.substring(1).split('&');
  const params = {};

  if (paramQueries.length > 0 && paramQueries[0] !== '') {
    for (let i = 0; i < paramQueries.length; i++) {
      const paramPair = paramQueries[i].split('=');

      params[paramPair[0]] = paramPair[1];
    }
  }
  return params;
};

let demo = null;
/**
 * Return true if ..?cmpdemo=1" is in URL.
 * @return {boolean}
 */
export const demoMode = () => {
  if (demo === null) {
    const {cmpdemo} = getUrlParams();

    if (cmpdemo) {
      demo = cmpdemo === '1';
    }
  }

  return demo;
};

let logger = null;
/**
 * Return true if ..?cmplogger=1" is in URL.
 * @return {boolean}
 */
export const loggerMode = () => {
  if (logger === null) {
    const {cmplogger} = getUrlParams();

    if (cmplogger) {
      logger = cmplogger === '1';
    }
  }

  return logger;
};
